module.exports = __webpack_public_path__ + "static/media/45.1efab225.png";